const Types = {
    CustomerPortalService: Symbol.for("CustomerPortalService"),
    CustomerPortalServiceConfig: Symbol.for("CustomerPortalServiceConfig"),
};

export { Types };
